module.exports = __webpack_public_path__ + "assets/img/13.8dc00151.png";